var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget"},[(_vm.editable)?_c('i',{staticClass:"el-icon-fa-trash delete-widget",on:{"click":_vm.deleteWidget}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"widget-container"},[_c(_vm.widget.widget,{tag:"component",attrs:{"options":_vm.widget.options,"widget":_vm.widget}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-097986d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/macarons/src/components/PortalWidget.vue
// module id = null
// module chunks = 